export const FALLBACK = [
  'https://crehana-vercel-images-prd.imgix.net/public/504bdf6a-58a9-4df4-922a-5ff5f4c2ae34-pepsico.png?auto=format&fit=clip',
  'https://crehana-vercel-images-prd.imgix.net/public/823cdea8-4e45-485d-9eb3-80cf1d9901f7-hp.png?auto=format&fit=clip',
  'https://crehana-vercel-images-prd.imgix.net/public/33e7d000-588f-4f4a-aae6-2f031a6fd011-chubb.png?auto=format&fit=clip',
  'https://crehana-vercel-images-prd.imgix.net/public/fca14e4e-647d-4b1c-97a6-08eb38a04de3-didi.png?auto=format&fit=clip',
  'https://crehana-vercel-images-prd.imgix.net/public/1c1b96da-a65c-4ea4-bd10-cdd07c95ac6e-yvesrocher.png?auto=format&fit=clip',
  'https://crehana-vercel-images-prd.imgix.net/public/4af36813-4f8c-4f3e-8fce-97f2ec2049e9-sodimac.png?auto=format&fit=clip',
];
